import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { QuestionResponse } from '../../models/assets/QuestionResponse';
import { UnfocusElementService } from '../../services/unfocus-element.service';
import { QuestionAsset } from '../../models/assets/QuestionAsset';
import { FileService } from '../../services/file.service';
import { ValidationService } from '../../services/validation.service';
import { AssetTypeService } from '../../services/asset-type.service';
import { ViewFileModalPage } from '../view-file-modal/view-file-modal.page';
import { FileSizeService } from 'src/app/services/file-size.service';
import { MessagesService } from 'src/app/services/messages.service';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AuthorService } from 'src/app/services/author.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { QuestionResponseObjectEditModalPage } from '../question-response-object-edit-modal/question-response-object-edit-modal.page';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { ImageSceneAssetRelation } from 'src/app/models/scene-asset-relations/imageSceneAssetRelation';
import { VideoSceneAssetRelation } from 'src/app/models/scene-asset-relations/videoSceneAssetRelation';
import { AudioSceneAssetRelation } from 'src/app/models/scene-asset-relations/AudioSceneAssetRelation';

@Component({
  selector: 'app-edit-responses-properties-modal',
  templateUrl: './edit-responses-properties-modal.page.html',
  styleUrls: ['./edit-responses-properties-modal.page.scss'],
})
export class EditResponsesPropertiesModalPage implements OnInit {
  public asset: AssetInScene;
  public currentScene: Scene; // USED ON HTML FILE
  public scenes: Scene[]; // USED ON HTML FILE
  public authorService: AuthorService;
  private _isModalOpen: boolean = false;
  public ionSelectFontOptions = {
    cssClass: 'select-font'
  };

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public fileService: FileService,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public fileSizeService: FileSizeService,
    public alertController: AlertController,
    public messagesService: MessagesService,
    public assetManagementService: AssetManagementService,
    public deepCopyService: DeepCopyService
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.validateAndCreateResponseAssets(this.asset);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  getResponseTextSize(questionResponse: QuestionResponse) {
    return (55 - questionResponse.textSize).toFixed(1);
  }

  setResponseTextSize(value, response: QuestionResponse, index: number) {
    let textSize: number = Number(value);
    if (textSize > 30) {
      textSize = 30;
    }

    if (textSize < 1) {
      textSize = 1;
    }

    if (!textSize) {
      textSize = 1;
    }


    textSize = 55 - textSize;
    response.textSize = Number(textSize.toFixed(1));

    let input = document.querySelector(`#question-asset-${this.asset.sceneAssetRelation.sceneAssetRelationId}-response-${index}`);
    if (input) {
      input.setAttribute('value', this.getResponseTextSize(response));
    }
  }

  changeTextScale(value: number, response: QuestionResponse) {

    var textScale = response.textSize;
    if (textScale > 54) textScale = 54;
    if (textScale < 25.1) textScale = 25.1;

    response.textSize = Number((textScale + value).toFixed(1));
  }

  async replaceMedia(event, response: QuestionResponse, type: string) {
    var projectId: string = '5a0ffb5a-475d-4307-bf05-237f82a9302d';
    var blobStorageLoc = await this.fileService.getBlobStorageLocation();
    var assetTypeId: number = this.assetTypeService.getId(type);
    if (this.validationService.isFileFormatCorrect(assetTypeId) == true) {
      var fileToUpload = event.target.files[0];
      var compressFile = false;

      if (type == 'Image')
        fileToUpload = await this.fileService.compressImage(fileToUpload);
      else if (type == 'Video')
        compressFile = await this.confirmIsToCompress();

      await this.messagesService.presentLoadingWindow('Uploading file, please wait.');

      /*this.fileService.uploadFile(type, fileToUpload, projectId, compressFile).subscribe(res => {
        let src = 'https://ecomstorageproduction.blob.core.windows.net/assessing-reality/' + projectId + '/' + res;
        switch (type) {
          case 'Image':
            response.imageSrc = src;
            response.imageFileSize = await this.fileSizeService.getFileSize(response.imageSrc);
            break;
          case 'Video':
            if (compressFile) {
              response.uploadStatus = 'uploading';
              response.videoSrc = this.fileService.videoAssetUploadingPlaceholder;
              this.fileService.addVideoToCheckUploadStatus('questionResponse', this.asset.sceneAssetRelation.sceneAssetRelationId, response, src, response.questionResponseIndex);
              this.fileService.initialiseVideoUploadStatusCheck();
            } else {
              response.uploadStatus = 'complete';
              response.videoSrc = src;
              response.videoFileSize = await this.fileSizeService.getFileSize(response.videoSrc);
            }
            break;
          case 'Audio':
            response.audioSrc = src;
            response.audioFileSize = await this.fileSizeService.getFileSize(response.audioSrc);
            break;
        }
        this.messagesService.loadingWindow.dismiss();
      }, async error => {
        let src = 'https://'+ blobStorageLoc +'.blob.core.windows.net/assessing-reality/' + projectId + '/' + error.error.text;
        switch (type) {
          case 'Image':
            response.imageSrc = src;
            response.imageFileSize = await this.fileSizeService.getFileSize(response.imageSrc);
            break;
          case 'Video':
            if (compressFile) {
              response.uploadStatus = 'uploading';
              response.videoSrc = this.fileService.videoAssetUploadingPlaceholder;
              this.fileService.addVideoToCheckUploadStatus('questionResponse', this.asset.sceneAssetRelation.sceneAssetRelationId, response, src, response.questionResponseIndex);
              this.fileService.initialiseVideoUploadStatusCheck();
            } else {
              response.uploadStatus = 'complete';
              response.videoSrc = src;
              response.videoFileSize = await this.fileSizeService.getFileSize(response.videoSrc);
            }
            break;
          case 'Audio':
            response.audioSrc = src;
            response.audioFileSize = await this.fileSizeService.getFileSize(response.audioSrc);
            break;
        }
        this.messagesService.loadingWindow.dismiss();
      });*/
    } else {
      this.validationService.createAlert('Unsupported ' + type + ' File Format');
    };
  }

  confirmIsToCompress(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      const alert = await this.alertController.create({
        header: 'Upload Video',
        message: '"Compress Video" option is recommended for quicker loading times, but may affect the video resolution.',
        cssClass: 'leave-alert',
        buttons: [{
          text: 'Compress Video & Upload',
          cssClass: 'leave-button',
          handler: () => {
            resolve(true);
          }
        }, {
          text: 'Upload Only',
          cssClass: 'leave-button',
          handler: () => {
            resolve(false);
          }
        }
        ]
      });
      await alert.present();
    });
  }

  linkedSceneToggle(ev, response) {
    if (response.hasLinkedScene) {
      if (response.linkedSceneID == 0) {
        this.setDefaultScene(response);
      }
      else if (this.scenes.filter(x => x.sceneId == response.linkedSceneID && x.active == true).length == 0) {
        this.setDefaultScene(response);
      }
    }
  }

  setDefaultScene(response) {
    var scenes = this.scenes.filter(x => x.sceneId != this.currentScene.sceneId && x.active == true);
    if (scenes.length > 0) {
      response.linkedSceneID = scenes[0].sceneId;
    }
    else {
      response.hasLinkedScene = false;
    }
  }

  countScenesExcludingCurrentScene() {
    if (this.scenes.filter(x => x.sceneId != this.currentScene.sceneId && x.active == true).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  async launchFilePreview(type: string, src: string) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewFileModalPage,
      id: 'asset-preview-' + type + '-modal', //Same Modal Size
      componentProps: {
        'fileType': type,
        'fileSrc': src
      }
    });

    modal.onDidDismiss().then(() => {
      this._isModalOpen = false;
    });

    return await modal.present();
  }

  getAsset() {
    return this.asset.baseAsset as QuestionAsset;
  }

  validateAndCreateResponseAssets(asset: AssetInScene) {
    let questionAsset = asset.baseAsset as QuestionAsset;
    questionAsset.responses.forEach(response => {
      if (!response.assets) response.assets = [];

      let imageTypeId = this.assetTypeService.getId('Image');
      let videoTypeId = this.assetTypeService.getId('Video');
      let audioTypeId = this.assetTypeService.getId('Audio');
      let imageAssetForQuestionResponse = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
      let videoAssetForQuestionResponse = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
      let audioAssetForQuestionResponse = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);

      if (!imageAssetForQuestionResponse) {
        imageAssetForQuestionResponse = this.authorService.addQuestionResponseMediaAsset(response, 'Image', 0);
        response.imageSceneAssetRelationId = imageAssetForQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
        response.assets.push(imageAssetForQuestionResponse);
      }
      if (!videoAssetForQuestionResponse) {
        videoAssetForQuestionResponse = this.authorService.addQuestionResponseMediaAsset(response, 'Video', 0);
        response.videoSceneAssetRelationId = videoAssetForQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
        response.assets.push(videoAssetForQuestionResponse);
      }
      if (!audioAssetForQuestionResponse) {
        audioAssetForQuestionResponse = this.authorService.addQuestionResponseMediaAsset(response, 'Audio', 0);
        response.audioSceneAssetRelationId = audioAssetForQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
        response.assets.push(audioAssetForQuestionResponse);
      }
    });
  }

  async editQuestionResponseObject(event, questionResponse: QuestionResponse, objectType: string) {
    this.unfocusService.unfocus(event);

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    let assetTypeId: number = this.assetTypeService.getId(objectType);
    let asset = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId == assetTypeId);

    this.hideModal();

    const questionResponseObjectEditModal = await this.modalController.create({
      component: QuestionResponseObjectEditModalPage,
      id: 'question-response-object-edit-modal',
      componentProps: {
        'title': questionResponse.text + ' - ' + objectType,
        'assetType': objectType,
        'asset': asset,
      }
    });

    questionResponseObjectEditModal.onDidDismiss().then((result) => {
      if (result.data && result.data.assetManagementPageId && result.data.asset) {
        if (result.data.assetManagementPageId !== result.data.asset.baseAsset.baseAssetId) {
          let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == result.data.assetManagementPageId);
          let baseAssetToCopy = this.deepCopyService.deepCopy(assetOnManagementPage);
          this.setUpAssetForQuestionResponse(questionResponse, baseAssetToCopy, objectType, result.data.asset);
        }
      } else if (result.data && result.data.asset) {
        let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == result.data.asset.baseAsset.baseAssetId);
        if (assetOnManagementPage) {
          let baseAssetToCopy = this.deepCopyService.deepCopy(result.data.asset.baseAsset);
          baseAssetToCopy.baseAssetId = 0;
          this.setUpAssetForQuestionResponse(questionResponse, baseAssetToCopy, objectType, result.data.asset);
        }
      }

      console.log(questionResponse);

      this._isModalOpen = false;
      this.showModal();
    });

    await questionResponseObjectEditModal.present();
  }

  setUpAssetForQuestionResponse(response: QuestionResponse, mediaAsset: MediaAsset, assetType: string, assetToCopy: any) {
    let assetToQuestionResponse = this.authorService.addSceneAssetRelation(mediaAsset);

    assetToCopy.toBeRemoved = true;

    assetToQuestionResponse.assets = [];
    assetToQuestionResponse.questionRules = [];
    assetToQuestionResponse.outcomeActions = [];

    assetToQuestionResponse.sceneAssetRelation.xPos = assetToCopy.sceneAssetRelation.xPos;
    assetToQuestionResponse.sceneAssetRelation.yPos = assetToCopy.sceneAssetRelation.yPos;
    assetToQuestionResponse.sceneAssetRelation.zPos = assetToCopy.sceneAssetRelation.zPos;
    assetToQuestionResponse.sceneAssetRelation.position = assetToCopy.sceneAssetRelation.position;
    assetToQuestionResponse.sceneAssetRelation.xScale = assetToCopy.sceneAssetRelation.xScale;
    assetToQuestionResponse.sceneAssetRelation.yScale = assetToCopy.sceneAssetRelation.yScale;
    assetToQuestionResponse.sceneAssetRelation.zScale = assetToCopy.sceneAssetRelation.zScale;
    assetToQuestionResponse.sceneAssetRelation.scale = assetToCopy.sceneAssetRelation.scale;
    assetToQuestionResponse.sceneAssetRelation.isVisible = assetToCopy.sceneAssetRelation.isVisible;

    switch (assetType) {
      case 'Image': {
        let imageSceneAssetRelation = assetToQuestionResponse.sceneAssetRelation as ImageSceneAssetRelation;
        imageSceneAssetRelation.borderSize = assetToCopy.sceneAssetRelation.borderSize;
        imageSceneAssetRelation.borderColour = assetToCopy.sceneAssetRelation.borderColour;
        response.imageSceneAssetRelationId = imageSceneAssetRelation.sceneAssetRelationId;
        break;
      }
      case 'Video': {
        let videoSceneAssetRelation = assetToQuestionResponse.sceneAssetRelation as VideoSceneAssetRelation;
        videoSceneAssetRelation.borderSize = assetToCopy.sceneAssetRelation.borderSize;
        videoSceneAssetRelation.borderColour = assetToCopy.sceneAssetRelation.borderColour;
        response.videoSceneAssetRelationId = videoSceneAssetRelation.sceneAssetRelationId;
        break;
      }
      case 'Audio': {
        let audioSceneAssetRelation = assetToQuestionResponse.sceneAssetRelation as AudioSceneAssetRelation;
        audioSceneAssetRelation.volume = assetToCopy.sceneAssetRelation.volume;
        audioSceneAssetRelation.positional = assetToCopy.sceneAssetRelation.positional;
        audioSceneAssetRelation.looping = assetToCopy.sceneAssetRelation.looping;
        audioSceneAssetRelation.autoplay = assetToCopy.sceneAssetRelation.autoplay;
        response.audioSceneAssetRelationId = audioSceneAssetRelation.sceneAssetRelationId;
        break;
      }
    }
    assetToQuestionResponse.toBeRemoved = false;
    response.assets.push(assetToQuestionResponse);
  }

  showModal() {
    document.getElementById('edit-responses-properties-modal').setAttribute('style', 'display: flex');
  }

  hideModal() {
    document.getElementById('edit-responses-properties-modal').setAttribute('style', 'display: none');
  }

}
